import { useLazyQuery } from '@apollo/client';
import { Container, Row, Col, Button, Spinner, Nav, NavItem } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import {
  callNativeMobileApp,
  AccessToQuery,
  createDateObject,
  useAppContext,
  useTranslator,
  withMobileAppMode,
} from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';

const PaymentPending = ({ token, description, mobileAppMode, mealPlanNavigation }) => {
  const { t } = useTranslator();
  const {
    images: { pendingPayment },
  } = useAppContext();
  const [fetchAccess, { loading }] = useLazyQuery(AccessToQuery, { fetchPolicy: 'network-only' });

  const checkAccess = async () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const response = await fetchAccess();
    if (response.data.me.diet.accessTo) {
      const accessTo = createDateObject(response.data.me.diet.accessTo);
      if (accessTo >= today) {
        window.location.reload();
      }
    }
  };

  const renderAction = () => {
    if (mobileAppMode) {
      return (
        <>
          <Button
            color="primary"
            className="w-100 mb-s"
            onClick={() =>
              callNativeMobileApp({
                action: 'open_modal',
                payload: {
                  target: 'price_list',
                },
              })
            }
          >
            {t('mealPlan.pendingPayment.screen.buyButton')}
          </Button>
          <Button
            color="secondary"
            outline
            className="w-100"
            onClick={checkAccess}
            disabled={loading}
          >
            {loading && (
              <Spinner color="primary" size="sm" className="me-2">
                {t('loading.message')}
              </Spinner>
            )}

            {t('mealPlan.pendingPayment.screen.refreshButton')}
          </Button>
        </>
      );
    }

    return (
      <>
        <Button
          color="primary"
          className="w-100 mb-s"
          tag={Link}
          to={'/cart/confirm/:token'.replace(':token', token)}
        >
          {t('mealPlan.pendingPayment.screen.buyButton')}
        </Button>
        <Button
          color="secondary"
          outline
          className="w-100"
          onClick={checkAccess}
          disabled={loading}
        >
          {loading && (
            <Spinner color="primary" size="sm" className="me-2">
              {t('loading.message')}
            </Spinner>
          )}
          {t('mealPlan.pendingPayment.screen.refreshButton')}
        </Button>
      </>
    );
  };

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('meals.navbarTitle')}</TitleBar>
      <div className="page-template-other full-height3a">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                {mealPlanNavigation && mealPlanNavigation.length > 0 && (
                  <div className="sub-navigation text-center">
                    <Container>
                      <Nav className="d-block">
                        {mealPlanNavigation.map((item) => (
                          <NavItem className="w-50">
                            <NavLink to={item.path} replace={true} className="nav-link">
                              {t(item.translationKey)}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                    </Container>
                  </div>
                )}
                <div
                  className={
                    mobileAppMode
                      ? 'other-container text-center d-flex align-items-center min-height'
                      : 'other-container text-center'
                  }
                >
                  <Row>
                    <Col xl={{ size: 6, offset: 3 }}>
                      <img src={pendingPayment} className="img-fluid mb-xl" alt="" />
                      <h2 className="title-medium semi-bold">
                        {t('mealPlan.pendingPayment.screen.title', {
                          products: description,
                        })}
                      </h2>
                      <p>{t('mealPlan.pendingPayment.screen.paymentWaitingContent')}</p>
                      <p>{t('mealPlan.pendingPayment.screen.payContent')}</p>
                      {renderAction()}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default withMobileAppMode(PaymentPending);
